import { iProfilePicService } from './profile-pic.types';
import { StorageFile, iFirestoreProfilePicStorage } from '../firestore-storage/firestore-storage.types';

export default class ProfilePicService implements iProfilePicService {
  storage: iFirestoreProfilePicStorage;

  constructor(storage: iFirestoreProfilePicStorage) {
    this.storage = storage;
  }

  upload(userId: string, file: File): Promise<StorageFile> {
    return this.storage.upload(userId, file);
  }
}
